import { Card, Grid, Typography, Button, Box, useTheme } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import HCarosel from '../../Component/Carosel/Carosel'
import MissionVission from '../../Component/MV/MV'
import College_Data from '../../Assets/JSON/MV.json'
import LawcourseData from './mbaCourse'
import PeopleIcon from '../../Assets/Icons/People_icon.svg'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { IMAGE_BASE_PATH_DBRAIMT } from '../../Config/Config'

const CourseOffered = () => {
  const location = useLocation()
  const College_DATA = location?.state?.College_details?.CourseOffered
  const [Selected_College_Data, setSelected_College_Data] = useState(null)
  const theme = useTheme()

  useEffect(() => {
    if (College_DATA) {
      Get_College_Data()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleButtonClick = () => {
    if (!Selected_College_Data?.SyllabusDoc?.CourseDocument) return

    const link = document.createElement('a')
    link.href =
      IMAGE_BASE_PATH_DBRAIMT + Selected_College_Data.SyllabusDoc.CourseDocument
    link.download =
      Selected_College_Data.SyllabusDoc.CourseDocument.split('/').pop()
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const Get_College_Data = () => {
    if (!College_Data?.College_CourseOffered_Details) {
      setSelected_College_Data(null)
      return
    }

    // Try to find matching course (case insensitive, flexible matching)
    const selected_College_data =
      College_Data.College_CourseOffered_Details.find(
        (item) =>
          item.CourseOffered.toLowerCase().includes(
            College_DATA.title.toLowerCase()
          ) ||
          College_DATA.title
            .toLowerCase()
            .includes(item.CourseOffered.toLowerCase())
      )

    setSelected_College_Data(selected_College_data || null)
  }

  return (
    <section style={{ backgroundColor: '#f5f5f5', paddingBottom: '50px' }}>
      {Selected_College_Data ? (
        <>
          <Box position="relative">
            <HCarosel />
            <Typography
              variant="h4"
              sx={{
                position: 'absolute',
                bottom: { xs: 10, md: 20 },
                left: { xs: 10, md: 20 },
                color: 'white',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                textShadow: '2px 2px 5px rgba(0, 0, 0, 0.8)',
                fontSize: { xs: '1.2rem', sm: '1.8rem', md: '2.5rem' },
                fontWeight: 'bold',
                maxWidth: { xs: '90%', md: '60%' },
              }}
            >
              Welcome to {College_DATA?.title}
            </Typography>
          </Box>

          <Grid container spacing={3} justifyContent="center" sx={{ mt: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{
                  backgroundColor: '#494798',
                  color: 'white',
                  height: 150,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 2,
                }}
              >
                <img src={PeopleIcon} alt="People Icon" width="50" />
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  backgroundColor: '#494798',
                  color: 'white',
                  height: 150,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6">Student Strength</Typography>
                <Typography variant="h4">
                  {Selected_College_Data?.Seats_Allotted || 'N/A'}
                </Typography>
              </Card>
            </Grid>
          </Grid>

          {Selected_College_Data?.MissionVission?.Mission?.discreption && (
            <MissionVission MV_DATA={Selected_College_Data.MissionVission} />
          )}

          {Selected_College_Data?.SyllabusDoc && (
            <Box display="flex" justifyContent="center" sx={{ mt: 5, p: 3 }}>
              <Box
                sx={{
                  width: { xs: '95%', sm: '85%', md: '60%' },
                  backgroundColor: 'white',
                  borderRadius: 2,
                  boxshadow: 2,
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  justifyContent: 'space-between',
                  gap: { xs: 2, sm: 3 },
                  p: { xs: 2, md: 3 },
                }}
              >
                <Box>
                  <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                    Syllabus:
                  </Typography>
                  <Typography variant="body1">
                    {Selected_College_Data.SyllabusDoc.DocumentTitle}
                  </Typography>
                </Box>

                <Button
                  variant="contained"
                  onClick={handleButtonClick}
                  sx={{
                    backgroundColor: '#494798',
                    color: 'white',
                    '&:hover': { backgroundColor: '#1565c0' },
                    alignSelf: { xs: 'stretch', sm: 'center' },
                  }}
                  endIcon={<FileDownloadIcon />}
                >
                  Download
                </Button>
              </Box>
            </Box>
          )}

          <LawcourseData law_data={Selected_College_Data} />
        </>
      ) : (
        <Typography
          variant="h4"
          sx={{
            textAlign: 'center',
            mt: 5,
            color: theme.palette.text.primary,
            background: theme.palette.background.paper,
          }}
        >
          {College_DATA
            ? 'No Data Found for this Course'
            : 'No Course Selected'}
        </Typography>
      )}
    </section>
  )
}

export default CourseOffered
